import React from 'react';
import { FAQ } from '../components/FAQ';

export default function FAQPage() {
  return (
    <div className="pt-24">
      <FAQ />
    </div>
  );
}